import {
  handleAvailable,
  handleRequest,
  handleUnavailable,
} from '../reducerHandlers';
import {
  IMAGE_DOWNLOAD_AVAILABLE,
  IMAGE_DOWNLOAD_REQUEST,
  IMAGE_DOWNLOAD_UNAVAILABLE,
  SNACK_ALERT_SET,
} from './constants';
import { createReducer } from './utils';

const defaultState = {
  lastDownloadedImage: null,
  isDownloadingImage: false,
};

export const reducer = createReducer(defaultState, {
  [IMAGE_DOWNLOAD_REQUEST]: handleRequest,
  [IMAGE_DOWNLOAD_AVAILABLE]: handleAvailable,
  [IMAGE_DOWNLOAD_UNAVAILABLE]: handleUnavailable,
});

/**
 * Requests an image for download; the API logs the requesting user before
 * returning it.
 *
 * @returns {Promise<{image: string, content_type: string} | null>} The base64
 * image and its content type, or null when the request fails.
 */
export function downloadImage(payload) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    const keyState = 'lastDownloadedImage';
    const loadingName = 'isDownloadingImage';
    dispatch({
      type: IMAGE_DOWNLOAD_REQUEST,
      payload: { loadingName },
    });
    try {
      const response = await dataSource.downloadImage(payload);
      dispatch({
        type: IMAGE_DOWNLOAD_AVAILABLE,
        payload: {
          keyState,
          data: { blobPath: payload.blobPath, imageType: payload.imageType },
          loadingName,
        },
      });
      return response;
    } catch (error) {
      console.error('error: ', error);
      dispatch({
        type: IMAGE_DOWNLOAD_UNAVAILABLE,
        payload: { keyState, loadingName, defaultState: null },
      });
      const snackAlert = {
        open: true,
        message: 'There was an error downloading the image. Please try again.',
        severity: 'error',
      };
      dispatch({ type: SNACK_ALERT_SET, payload: { snackAlert } });
      return null;
    }
  };
}
